import script from "./ProviderSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderSelect.vue?vue&type=script&setup=true&lang=js"

import "./ProviderSelect.vue?vue&type=style&index=0&id=655b6833&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-655b6833"]])

export default __exports__